import '@babel/polyfill'
import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'
import router from './router'
import store from './store'

import vueTopprogress from "vue-top-progress";
 
Vue.use(vueTopprogress);

Vue.config.productionTip = false

Vue.prototype.$fetch = function(url, method, data) {
    return new Promise((resolve, reject) => {
        fetch(url, {
            method: method || "GET",
            body: JSON.stringify(data),
            mode: "cors",
            redirect: "follow",
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Authorization": store.state.user && store.state.user.auth_token ? store.state.user.auth_token : undefined
            }
        })
        .then(response => resolve(response))
        .catch(error => reject(error));
    });
};

new Vue({
  router,
  store,
  render: h => h(App),
  created() {

    let data = localStorage.getItem("session") || "null";

    data = JSON.parse(data);

    if (data) {
      store.commit("login", data);
      router.replace("/dashboard/");
    }

  }
}).$mount('#app')
